<template>
  <div>
    <contentEngine
      contentTitle="traits"
      :editMode="false"
      :contentTagging="contentTagging"
      :sections="sections"
      :examples="examples" />
    <v-tabs
      v-model="traitGroup"
      background-color="primary"
      dark
      fixed-tabs
      center-active
      @change="textKey++;">
      <v-tab v-for="(traitType, typeIndex) in traitTypes" :key="typeIndex">
        <avatarStat v-if="typeIndex > 0" :traitType="traitType.toLowerCase()" />
        <span v-else>
          <font size="4">All</font>
        </span>
      </v-tab>
    </v-tabs>
    <br />
    <v-row justify="center">
      <contentEngine
        :contentTitle="traitTypes[traitGroup] + '|Traits'"
        :key="textKey"
        :editMode="false"
        :contentTagging="contentTagging"
        :sections="sections"
        :examples="examples"
        :ignoredWords="['traits', traitTypes[traitGroup] + '|traits']" />
    </v-row>
    <v-card color="primary" elevation="0" class="white--text">
      <v-card-title>
        <h3>{{ traitTypes[traitGroup] }} Traits</h3>
        <v-spacer />
        <v-text-field v-model="search" dark append-icon="mdi-magnify" />
        <v-btn v-if="editMode && traitGroup > 0" dark icon @click="setNew">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="white--text">
        <v-data-table
          :headers="columns"
          :items="sortedTraits"
          :search="search"
          hide-default-footer
          :items-per-page="sortedTraits.length"
          dark
          single-expand
          :expanded.sync="expandedRow"
          class="secondary"
          item-key="name"
          :key="tableKey"
          @click:row="expandRow">
          <template v-slot:item.type="{ item }">
            <avatarStat :traitType="item.type.toLowerCase()" />
          </template>
          <template v-slot:item.requirements="{ item }">
            <template v-for="(req, reqIndex) in item.requirements">
              {{ req }}
              <br :key="reqIndex">
            </template>
          </template>
          <template v-slot:item.description="{ item }">
            {{ descSubstring(item.description) }}
          </template>
          <template v-if="editMode" v-slot:item.actions="{ item }">
            <v-btn dark icon @click="dialogKey++; traitEditor = true; editTrait = item;">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td style="background-color: #78909C" :colspan="headers.length">
              <contentEngine
                :content="item.description"
                contentTitle=""
                headerType="None"
                :editMode="false"
                :contentTagging="contentTagging"
                :sections="sections"
                :examples="examples" />
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="traitEditor" :key="dialogKey" max-width="300">
      <traitCardEdit v-if="traitEditor" :trait="editTrait" @close="traitEditor = false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
    avatarStat: () => import('./avatarStat'),
    traitCardEdit: () => import('./traitCardEdit'),
    contentEngine: () => import('../contentEngine/contentEngine')
  },
  data() {
    return {
      expandedRow: [],
      traitEditor: false,
      editTrait: {},
      traitGroup: 0,
      textKey: 0,
      dialogKey: 0,
      tableKey: 0,
      traitTypes: [
        'All',
        'General',
        'Physique',
        'Finesse',
        'Mind',
        'Spirit',
        'Physique-Finesse',
        'Physique-Mind',
        'Physique-Spirit',
        'Finesse-Mind',
        'Finesse-Spirit',
        'Mind-Spirit'
      ],
      search: ''
    };
  },
  methods: {
    descSubstring(item) {
      const lines = item.split('\n');
      let returnLine = '';
      if (lines.length === 1) {
        returnLine = lines[0];
      } else {
        lines.forEach((line) => {
          if (returnLine === '' && !line.includes('Cost:') && !line.includes('Save:')) {
            returnLine = line;
          }
        });
      }

      if (returnLine.length > 100) {
        returnLine = returnLine.substring(0, 100) + '...';
      }

      return returnLine;
    },
    expandRow(row) {
      if (this.expandedRow[0] && this.expandedRow[0] === row) {
        this.expandedRow = [];
      } else {
        this.expandedRow = [row];
      }
      this.tableKey++;
    },
    setNew() {
      this.editTrait = { new: true, type: this.traitTypes[this.traitGroup].toLowerCase() };
      this.traitEditor = true;
    }
  },
  computed: {
    ...mapState(['editMode', 'contentTagging']),
    ...mapState('newACTSContent', ['sections', 'examples']),
    ...mapState('newACTSTraits', ['traits']),
    columns() {
      const columns = [
        {
          text: 'Type',
          value: 'type',
          width: '75px'
        },
        {
          text: 'Name',
          value: 'name',
          width: '150px'
        },
        {
          text: 'Requirements',
          value: 'requirements',
          width: '200px'
        },
        {
          text: 'Description',
          value: 'description'
        }
      ];
      if (this.editMode) {
        columns.push({
          text: '',
          value: 'actions',
          width: '50px'
        });
      }

      return columns;
    },
    sortedTraits() {
      if (this.traitGroup === 0) {
        return this.traits;
      }
      return this.traits.filter(trait => trait.type === this.traitTypes[this.traitGroup].toLowerCase());
    }
  }
};
</script>

<style>
.secondary {
  background-color: #607D8B
}
</style>
